import { useContext, useState } from "react";
import { ProfileContext } from "../../../context/ProfileContext";
import { FaCamera } from "react-icons/fa";

const ProfileCard = () => {
  const { user } = useContext(ProfileContext);
  const photo =
    user?.type === "wcPartner"
      ? user?.partnerPhoto
      : user?.compliance?.partnerPhoto;
  const [previewImage, setPreviewImage] = useState(null);

  return (
    <div className="card profile-card">
      <div className="avatar-wrapper">
        <img
          src={photo || "/avatar-placeholder.png"}
          alt={user?.fullName}
          className="profile-avatar"
        />

        {photo && (
          <button
            className="avatar-view-btn"
            onClick={() => setPreviewImage(photo)}
            title="View Photo"
          >
            <FaCamera size={12} />
          </button>
        )}
      </div>

      <h3>{user?.fullName}</h3>
      <p className="role">Elite Referral Partner</p>

      <div className="badges">
        <span className="badge id">ID: {user?.partnerCode}</span>
        <span className="badge level">Level {user?.level}</span>
      </div>

      {previewImage && (
        <div className="rp-image-preview-overlay">
          <div className="rp-image-preview-modal">
            <button
              className="rp-image-preview-close"
              onClick={() => setPreviewImage(null)}
            >
              ✕
            </button>
            <img src={previewImage} alt="Preview" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileCard;
